import isElementExist from './helpers/isElementExist';
import initHeaderOffset from './modules/headerOffset';
import stickyHeader from './modules/stickyHeader';
import quotesSlider from './modules/quotesSlider';
import headerMenu from './modules/headerMenu';
import accordion from './modules/accordion';
import starsRating from './modules/starsRating';
import togglePassword from './modules/togglePassword';
import pharmacy from './modules/pharmacy';
import popupCta from './modules/popupCta';
import popupLogin from './modules/popupLogin';
import initJcf from './modules/initJcf';
import weightCalculator from './modules/weightCalculator';
import initGalleryCarousel from './modules/galleryCarousel';
import cookieCheck from './modules/cookieCheck';
import phoneOrderUser from './modules/phoneOrderUser';
import partnerWithUs from './modules/partnerWithUs';
import cookieConsentService from './services/cookie-consent';

window.addEventListener('DOMContentLoaded', () => {
  initJcf();
  isElementExist('.header', initHeaderOffset);
  isElementExist('.header', stickyHeader);
  isElementExist('.header', headerMenu);
  isElementExist('#no-cookies-warning', cookieCheck);
  isElementExist('#phone-order-user-notification', phoneOrderUser);
  isElementExist('.accordion', () => {
    accordion({
      containerClass: '.accordion',
      elementClass: 'accordion_item',
      triggerClass: 'accordion_button',
      panelClass: 'accordion_dropdown',
      activeClass: '_active',
    });
  });
  isElementExist('.modern-accordion', () => {
    accordion({
      containerClass: '.modern-accordion',
      elementClass: 'accordion_item',
      triggerClass: 'accordion_button',
      panelClass: 'accordion_dropdown',
      activeClass: 'accordion_item_active',
    });
  });
  isElementExist('.quotes-slider', quotesSlider);
  isElementExist('.stars-rating', starsRating);
  isElementExist('.input-password', togglePassword);
  isElementExist('.popup-cta-trigger', popupCta);
  isElementExist('.popup-login-trigger', popupLogin);
  isElementExist('app-find-a-lab', pharmacy);
  isElementExist('#weight-calculator', weightCalculator);
  isElementExist('.partner-with-us-page', partnerWithUs);
  isElementExist('#gallery-carousel', () => {
    initGalleryCarousel(document.querySelector('#gallery-carousel'));
  });
  isElementExist('.cookie-consent', cookieConsentService);
});
